import { RouteComponentProps, withRouter } from "react-router-dom";

type IErrorPageProps = RouteComponentProps<any>;
const ErrorPage: React.FunctionComponent<IErrorPageProps> = () => {
  throw new Error("Error");
};

export default withRouter(ErrorPage);
